module.exports = {
  pointer: 'Your KYC status will be reset if you change your details.',
  
  locked: {
    heading: 'Form is locked',
    text: 'Changes to your details are disabled while verification is in progress.'
  },
  switchable: {
    heading: 'Changing your details will reset your KYC status',
    text: 'If you change your details now your KYC status will be reset, and your profile will have to be reviewed again before you can invest.'
  }
}